module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAbCAYAAAB836/YAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEGSURBVHgB5ZbhDYIwEEY/DP9lA7uBuolOoBuoEziKboAbwAbiBMYJwAnqHbkaBEpKIcbEl1ysJX1cry0AEFprRZFQ5NqPmB3sCqRxpYgwjIJiCbEzJ4reUpndWRwJKmkreMKJiCPnKWvuDAgMwHgmGJnfF4b1DlnpBM1tdKAyX9BXKKgW4RQOtK6yZPkhoMuPLtHbM/a2CS0XuYaqW4GMcljXO22LsoDn2XauYQtPGlJUxny3hjHcpsx7M2uYjV3+R9qdTd1jq6Gin1l3cmUNs6qw9Pzx48vnfWITptLewxNKxozNeFFW1IilI0V/zFFltuYOR4q79oc/EHbsqp/fOfy4mXP9An4BbW/2Nf0oAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/wenzhenjilu_bai.png
// module id = leDP
// module chunks = 5